module.exports = __webpack_public_path__ + "static/media/banner_formacao_professores.a2d95a76.webp";